var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "viq-outline" }, [
    _c("h3", { staticClass: "viq-outline__title" }, [_vm._v("Report Outline")]),
    _vm._v(" "),
    _c("p", { staticClass: "viq-outline__desc" }, [
      _vm._v(
        "\n    Review and customise the sections. Add, remove, or reorder as needed.\n  "
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "viq-outline__sections" },
      _vm._l(_vm.localOutline, function (section, i) {
        return _c("div", { key: i, staticClass: "viq-outline__section" }, [
          _c("div", { staticClass: "viq-outline__section-drag" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "12",
                  height: "12",
                  viewBox: "0 0 12 12",
                  fill: "none",
                },
              },
              [
                _c("circle", {
                  attrs: { cx: "4", cy: "2", r: "1", fill: "currentColor" },
                }),
                _c("circle", {
                  attrs: { cx: "8", cy: "2", r: "1", fill: "currentColor" },
                }),
                _vm._v(" "),
                _c("circle", {
                  attrs: { cx: "4", cy: "6", r: "1", fill: "currentColor" },
                }),
                _c("circle", {
                  attrs: { cx: "8", cy: "6", r: "1", fill: "currentColor" },
                }),
                _vm._v(" "),
                _c("circle", {
                  attrs: { cx: "4", cy: "10", r: "1", fill: "currentColor" },
                }),
                _c("circle", {
                  attrs: { cx: "8", cy: "10", r: "1", fill: "currentColor" },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "viq-outline__section-content" },
            [
              _c("el-input", {
                attrs: { size: "small", placeholder: "Section title" },
                model: {
                  value: _vm.localOutline[i].title,
                  callback: function ($$v) {
                    _vm.$set(_vm.localOutline[i], "title", $$v)
                  },
                  expression: "localOutline[i].title",
                },
              }),
              _vm._v(" "),
              _vm.localOutline[i].editing
                ? _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      size: "small",
                      placeholder: "Section description (optional)",
                    },
                    model: {
                      value: _vm.localOutline[i].description,
                      callback: function ($$v) {
                        _vm.$set(_vm.localOutline[i], "description", $$v)
                      },
                      expression: "localOutline[i].description",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "viq-outline__section-actions" }, [
            _c(
              "button",
              {
                staticClass: "viq-outline__section-btn",
                attrs: { title: "Toggle description" },
                on: {
                  click: function ($event) {
                    return _vm.toggleEdit(i)
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "12",
                      height: "12",
                      viewBox: "0 0 12 12",
                      fill: "none",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M8.5 1.5l2 2-7 7H1.5V8.5l7-7z",
                        stroke: "currentColor",
                        "stroke-width": "1",
                        "stroke-linecap": "round",
                      },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            i > 0
              ? _c(
                  "button",
                  {
                    staticClass: "viq-outline__section-btn",
                    attrs: { title: "Move up" },
                    on: {
                      click: function ($event) {
                        return _vm.moveUp(i)
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "12",
                          height: "12",
                          viewBox: "0 0 12 12",
                          fill: "none",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M6 2v8M3 5l3-3 3 3",
                            stroke: "currentColor",
                            "stroke-width": "1.2",
                            "stroke-linecap": "round",
                          },
                        }),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            i < _vm.localOutline.length - 1
              ? _c(
                  "button",
                  {
                    staticClass: "viq-outline__section-btn",
                    attrs: { title: "Move down" },
                    on: {
                      click: function ($event) {
                        return _vm.moveDown(i)
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "12",
                          height: "12",
                          viewBox: "0 0 12 12",
                          fill: "none",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M6 10V2M3 7l3 3 3-3",
                            stroke: "currentColor",
                            "stroke-width": "1.2",
                            "stroke-linecap": "round",
                          },
                        }),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "viq-outline__section-btn viq-outline__section-btn--delete",
                attrs: { title: "Remove section" },
                on: {
                  click: function ($event) {
                    return _vm.removeSection(i)
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "12",
                      height: "12",
                      viewBox: "0 0 12 12",
                      fill: "none",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M3 3l6 6M9 3l-6 6",
                        stroke: "currentColor",
                        "stroke-width": "1.2",
                        "stroke-linecap": "round",
                      },
                    }),
                  ]
                ),
              ]
            ),
          ]),
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "button",
      { staticClass: "viq-outline__add", on: { click: _vm.addSection } },
      [
        _c(
          "svg",
          {
            attrs: {
              width: "12",
              height: "12",
              viewBox: "0 0 12 12",
              fill: "none",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M6 1v10M1 6h10",
                stroke: "currentColor",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
              },
            }),
          ]
        ),
        _vm._v("\n    Add Section\n  "),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "viq-outline__refine" },
      [
        _c(
          "el-input",
          {
            attrs: {
              size: "small",
              placeholder:
                "Refine instructions (e.g., 'add a section on licensing requirements')",
            },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.refine.apply(null, arguments)
              },
            },
            model: {
              value: _vm.refineInstructions,
              callback: function ($$v) {
                _vm.refineInstructions = $$v
              },
              expression: "refineInstructions",
            },
          },
          [
            _c(
              "el-button",
              {
                attrs: { slot: "append", loading: _vm.refining },
                on: { click: _vm.refine },
                slot: "append",
              },
              [_vm._v("\n        Refine\n      ")]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "viq-outline__actions" },
      [
        _c("el-button", { on: { click: _vm.goBack } }, [_vm._v("Back")]),
        _vm._v(" "),
        _c(
          "el-button",
          {
            attrs: { type: "primary", disabled: _vm.localOutline.length === 0 },
            on: { click: _vm.confirm },
          },
          [_vm._v("\n      Generate Report\n    ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }